import { inject, Injectable, isSignal, Signal, signal } from '@angular/core';
import { NGX_PFE_CONFIGURATION, NgxPfeModuleConfiguration } from '../../models/ngx-pfe-module-configuration.model';

@Injectable()
export class PfeModuleConfigurationService {
  private readonly NGX_PFE_CONFIGURATION = inject(NGX_PFE_CONFIGURATION);

  public get pfeModuleConfig(): Signal<NgxPfeModuleConfiguration> {
    if (isSignal(this.NGX_PFE_CONFIGURATION)) {
      return this.NGX_PFE_CONFIGURATION;
    }

    const ngxPfeModuleConfigurationSignal = signal<NgxPfeModuleConfiguration>(this.NGX_PFE_CONFIGURATION);
    return ngxPfeModuleConfigurationSignal;
  }
}
